var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.lang.infotext_1)+": "),_c('b',[_vm._v(_vm._s(_vm.selectedLibrary))]),_c('br'),_vm._v("\n    "+_vm._s(_vm.lang.infotext_2)+": "),_c('b',[_vm._v(_vm._s(_vm.libraryCategory))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3756c6f3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/InfoElementComponent.vue
// module id = null
// module chunks = 